var procedure_archive = (function( $ ) {

	var $procedures;

	var _init = function() {
		$procedures = $( '.desktop ul.procedures' );

		if ( $procedures.length > 0 ) {
			$procedures.find( 'a' ).on( 'mouseenter', _show_image );
			$procedures.find( 'a' ).on( 'focusin', _show_image );

			$procedures.find( 'a' ).on( 'mouseleave', _hide_image );
			$procedures.find( 'a' ).on( 'focusout', _hide_image  );
		}
	};

	var _show_image = function( e ) {
		var $anchor = $( this );
		var procedure = $anchor.data( 'procedure' );

		$procedures.find( 'a' ).removeClass( 'active' );
		$( '.procedure-image' ).removeClass( 'active' );

		$anchor.addClass( 'active' );
		$( '.procedure-image.' + procedure ).addClass( 'active' );
	};

	var _hide_image = function( e ) {
		var $anchor = $( this );
		var procedure = $anchor.data( 'procedure' );

		$anchor.removeClass( 'active' );
		$( '.procedure-image.' + procedure ).removeClass( 'active' );

		setTimeout( function() {
			if ( $( '.procedure-image.active' ).length < 1 ) {
				$( '.procedure-image.default' ).addClass( 'active' );
			}
		}, 200 );
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = procedure_archive;